import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Badge from 'react-bootstrap/Badge';
import { OrderForListing } from '../../models/OrderForListing';

interface IOrderWithPrescriptionEyeGlassesForDifferentPersonsPopoverProps {
  orderForListing: OrderForListing;
}

export const OrderWithPrescriptionEyeGlassesForDifferentPersonsPopover: React.FC<IOrderWithPrescriptionEyeGlassesForDifferentPersonsPopoverProps> = ({
  orderForListing
}) => {

  let popover = orderForListing.orderWithPrescriptionEyeGlassesForDifferentPersons ? (
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>Óculos de grau para pessoas diferentes</Tooltip>}
      >
        <span style={{ fontSize: '0.8em' }}><Badge pill bg='primary'>2</Badge></span>
      </OverlayTrigger>
    </span>
  ) : null;

  if (!popover && orderForListing.nonProgressivePrescriptionOrderWithMoreThanOneLens) {
    popover = (
      <span style={{ marginLeft: '5px' }}>
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip>Pedido "não progressiva" com várias lentes</Tooltip>}
        >
          <span style={{ fontSize: '0.8em' }}><Badge pill bg='danger'>NP+VL</Badge></span>
        </OverlayTrigger>
      </span>
    );
  }

  return popover;
}